import React, { FC } from 'react';

const identity = (x) => x;

export const createHOCWithHookInside =
  (displayName, useHook, mapOuterPropsToHookArgs = identity, mapHookResultToInnerProps = identity) =>
  (BaseComponent) => {
    const Wrapper: FC = (props) => {
      const hookResult = useHook(mapOuterPropsToHookArgs(props));

      return <BaseComponent {...props} {...mapHookResultToInnerProps(hookResult)} />;
    };

    Wrapper.displayName = displayName;

    return Wrapper;
  };
